import { PageTypes } from "@/App";
import { pagesApi, Template } from "@/redux/reducer/pages.api";
import { debounceAsync } from "@/shared/utils";
import Axios from "axios";
import { toast } from "react-toastify";
import store from "@/redux/store";

export const service = {
  fetchTemplate: async (url: string) => {
    return Axios.get(url).then((res) => res.data);
  },
  saveTemplate: debounceAsync(
    async (
      data: FormData,
      currentTemplate: Template & { type: PageTypes; explicit?: boolean }
    ) => {
      const saveUrl = new URL(
        `${process.env.API_URL}/update/${currentTemplate.type}/${currentTemplate.id}`
      );
      saveUrl.searchParams.set("name", currentTemplate.name);
      currentTemplate.explicit &&
        saveUrl.searchParams.set("saveRevision", "true");

      const savePromise = Axios.put(saveUrl.toString(), data).then(() => {
        if (currentTemplate.explicit) {
          store.dispatch(pagesApi.util.invalidateTags(["Templates"]));
        }
      });

      return toast.promise(savePromise, {
        pending: currentTemplate.explicit
          ? "Creating new revision..."
          : "Saving files...",
        success: currentTemplate.explicit
          ? "New revision created"
          : "Files saved",
        error: "Failed to save files",
      });
    },
    500
  ),
};

export interface IMediaFile {
  extension: string;
  height: number;
  link: string;
  thumbnail: string;
  name: string;
  size: number;
  width: number;
}

export interface IMediaResponse {
  files: IMediaFile[];
  next_page: number | null;
  page: number;
  page_size: number;
  prev_page: number | null;
  status: "ok";
  total_files: number;
  total_pages: number;
}
